import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import DemsEvents from './DemsEvents';

import DemsDetailsSectionInfo from './details/sections/DemsDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<DemsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="dems_descriptionhtml"
				value={props.model.dems_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: DemsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
